module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vendo12-b28d85a89ce715293cb8af6f62513f57.jpg";